module.exports = __webpack_public_path__ + "img/social-cta_en.7ac3684.jpg";